export default "__VITE_ASSET__wQ1n$gXR__"